import { Markdown } from "components/Form/components/Markdown/Markdown";
import { MarkdownWidgetConfig, WidgetComponentProps } from "../types";

/**
 * `markdown` widget — renders static markdown content (notes, runbook links, …).
 */
export const MarkdownWidget = ({ widget, config }: WidgetComponentProps<MarkdownWidgetConfig>) => {
    const text = config?.text ?? "";
    if (!text.trim()) {
        return <div className="DashboardWidget__empty">No content.</div>;
    }
    return <Markdown markdownString={text} uniqueKey={widget.uid} canCopy={false} />;
};
